// extracted by mini-css-extract-plugin
export default {"module":"dropdown_module__TgJWY"};